import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import ThreeBackground from '../aether/components/ThreeBackground';
import Logo from '../../components/Logo';

export default function GamingNews() {
  const navigate = useNavigate();
  const [newsArticles, setNewsArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fallback mock data in case the API fails
  const mockArticles = [
    {
      id: 1,
      title: "Unreal Engine 5.4 Drives Next-Gen Orbital Sims",
      category: "Engine Tech",
      date: "Oct 24, 2026",
      image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&h=400&fit=crop",
      excerpt: "Epic's latest update introduces hyper-realistic zero-gravity physics solvers, revolutionizing how aerospace engineers simulate station environments before deployment.",
      link: "#"
    },
    {
      id: 2,
      title: "Neural-Linked VR: The Future of Dogfighting",
      category: "Hardware",
      date: "Oct 22, 2026",
      image: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=800&h=400&fit=crop",
      excerpt: "New BCI (Brain-Computer Interface) helmets are cutting reaction times in combat flight simulators by 40%. The military tech history community is watching closely.",
      link: "#"
    },
    {
      id: 3,
      title: "AI NPCs Achieve Turing-Level Military Strategy",
      category: "Artificial Intelligence",
      date: "Oct 20, 2026",
      image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&h=400&fit=crop",
      excerpt: "Generative AI commanders in the latest grand strategy titles are executing tactical maneuvers that mimic historical war space generals with terrifying accuracy.",
      link: "#"
    },
    {
      id: 4,
      title: "Unreal Engine 5.5 Introduces Built-in Generative AI Video Assets",
      category: "Engine Tech",
      date: "Oct 19, 2026",
      image: "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?w=800&h=400&fit=crop",
      excerpt: "Epic Games revealed that UE5.5 will feature direct integration with generative AI video models, allowing developers to create cinematic cutscenes on the fly using text prompts.",
      link: "#"
    },
    {
      id: 5,
      title: "AI News: Top 10 Games Using Video AI for Dynamic Storytelling",
      category: "Artificial Intelligence",
      date: "Oct 18, 2026",
      image: "https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?w=800&h=400&fit=crop",
      excerpt: "From procedurally generated video logs in space horror games to dynamically altering TV screens in city sims, Video AI is changing how narratives are delivered to the player.",
      link: "#"
    }
  ];

  useEffect(() => {
    const fetchLiveNews = async () => {
      try {
        // Fetching live real-world news about GTA VI, VFX Animation, and Gaming from Google News RSS converted to JSON
        const rssUrl = encodeURIComponent("https://news.google.com/rss/search?q=GTA+VI+VFX+Animation+Gaming+News&hl=en-US&gl=US&ceid=US:en");
        const res = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${rssUrl}`);
        const data = await res.json();
        
        if (data.status === 'ok' && data.items && data.items.length > 0) {
          const liveArticles = data.items.slice(0, 15).map((item, index) => {
            // Attempt to extract an image from the description HTML or use a fallback
            let imgMatch = item.description?.match(/<img[^>]+src="([^">]+)"/);
            let imgUrl = imgMatch ? imgMatch[1] : null;
            
            // Assign some high-quality unsplash fallbacks based on index if no image found
            const fallbackImages = [
              "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1552820728-8b83bb6b773f?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800&h=400&fit=crop",
              "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop"
            ];
            if (!imgUrl) imgUrl = fallbackImages[index % fallbackImages.length];

            return {
              id: item.guid || index,
              title: item.title,
              category: "Live Gaming Update",
              date: new Date(item.pubDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }),
              image: imgUrl,
              excerpt: item.description?.replace(/<[^>]+>/g, '').substring(0, 150) + "...", // Strip HTML
              link: item.link
            };
          });
          setNewsArticles(liveArticles);
        } else {
          setNewsArticles(mockArticles);
        }
      } catch (error) {
        console.error("Failed to fetch live news:", error);
        setNewsArticles(mockArticles);
      } finally {
        setLoading(false);
      }
    };

    fetchLiveNews();
  }, []);

  return (
    <div className="min-h-screen text-aether-light font-sans relative overflow-x-hidden bg-background">
      <ThreeBackground />

      {/* Top Navbar */}
      <header className="fixed top-0 w-full z-50 bg-background/40 backdrop-blur-[40px] border-b border-primary/10 h-20">
        <div className="flex justify-between items-center w-full px-8 max-w-7xl mx-auto h-full">
          <div className="cursor-pointer" onClick={() => navigate('/')}>
            <Logo />
          </div>
          <nav className="hidden md:flex items-center space-x-12">
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/curation')}>Curation</span>
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/')}>Feed</span>
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/salon')}>Salon</span>
            <span className="font-label-caps text-label-caps text-primary border-b border-primary pb-1 cursor-pointer">Game News</span>
          </nav>
          <div className="flex items-center gap-4">
            <span className="material-symbols-outlined cursor-pointer hover:opacity-80 transition-opacity">notifications</span>
            <span className="material-symbols-outlined cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('/curation')}>account_circle</span>
          </div>
        </div>
      </header>

      {/* Main Layout */}
      <div className="max-w-7xl mx-auto pt-32 px-4 pb-12 flex gap-8 relative z-10">
        
        {/* Left Sidebar */}
        <div className="hidden lg:block w-64 flex-shrink-0 space-y-8">
          <div className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)]">
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/')}>
                <span className="material-symbols-outlined text-lg">home</span> Feed
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/curation')}>
                <span className="material-symbols-outlined text-lg">explore</span> Curation
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/salon')}>
                <span className="material-symbols-outlined text-lg">groups</span> Salon
              </li>
              <li className="flex items-center gap-3 cursor-pointer text-primary mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)]">
                <span className="material-symbols-outlined text-lg">sports_esports</span> Game News
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-on-surface-variant" onClick={() => navigate('/architecture')}>
                <span className="material-symbols-outlined text-lg">domain</span> Architecture
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-[#d4af37] transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-on-surface-variant" onClick={() => navigate('/contracts')}>
                <span className="material-symbols-outlined text-lg">work</span> Contracts
              </li>
            </ul>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 max-w-3xl space-y-8">
          <div className="mb-10">
            <h2 className="font-playfair text-4xl text-primary mb-2">Live Industry Intelligence</h2>
            <p className="text-sm text-on-surface-variant/60 font-light tracking-widest uppercase">Real-Time updates on GTA VI, VFX Animation & Game Tech</p>
          </div>

          <div className="space-y-8">
            {loading ? (
              <div className="text-center py-20">
                <span className="material-symbols-outlined animate-spin text-4xl text-primary mb-4">sync</span>
                <p className="text-sm text-primary tracking-widest uppercase animate-pulse">Syncing Global Data Feeds...</p>
              </div>
            ) : (
              newsArticles.map((article, idx) => (
                <motion.article 
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1, duration: 0.5 }}
                  key={article.id} 
                  onClick={() => window.open(article.link, '_blank')} 
                  className="glass-panel rounded-2xl border border-[rgba(255,255,255,0.05)] overflow-hidden group cursor-pointer hover:border-primary/30 transition-colors"
                >
                  <div className="aspect-[21/9] overflow-hidden relative">
                    <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute top-4 left-4 px-3 py-1 bg-black/60 backdrop-blur-md rounded-full border border-white/10">
                      <span className="text-[10px] uppercase tracking-widest text-primary font-bold flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span> {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <span className="text-xs text-on-surface-variant/50 uppercase tracking-widest block mb-2">{article.date}</span>
                    <h3 className="font-playfair text-2xl text-white mb-3 group-hover:text-primary transition-colors">{article.title}</h3>
                    <p className="text-sm text-white/70 font-light leading-relaxed mb-6">
                      {article.excerpt}
                    </p>
                    <button className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary hover:text-white transition-colors">
                      Read Full Report <span className="material-symbols-outlined text-[16px]">open_in_new</span>
                    </button>
                  </div>
                </motion.article>
              ))
            )}
          </div>
        </div>

      </div>
    </div>
  );
}
